var map = {
	"./arrow-down.svg": 28755,
	"./ascent.svg": 84373,
	"./button.svg": 89898,
	"./chart-line.svg": 29960,
	"./component.svg": 12641,
	"./decline.svg": 94855,
	"./file-doc.svg": 29228,
	"./file-excel.svg": 70041,
	"./file-image.svg": 84278,
	"./file-pdf.svg": 44865,
	"./file-txt.svg": 43566,
	"./file-video.svg": 53870,
	"./file-zip.svg": 56050,
	"./home.svg": 83853,
	"./logo-small.svg": 3530,
	"./menufold.svg": 48134,
	"./permission.svg": 43483,
	"./ppt文件_file-ppt.svg": 20442,
	"./product.svg": 25646,
	"./select.svg": 45217,
	"./system.svg": 90243,
	"./table.svg": 64636,
	"./time.svg": 13332,
	"./user.svg": 27838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;